import React from 'react'
import { Redirect, Route, RouteProps } from 'react-router-dom'
import { APP_BASE_ROUTE, AUTH_REDIRECT_PARAM } from '../../constants'
import { BetterComponent } from '../better-component/better-component'
import { PlatformUserContext } from '@pushly/aqe/lib/providers/user-preferences-provider/internal/index'

interface IProps extends RouteProps {
    preAuth?: boolean
}

export class AppRoute extends BetterComponent<IProps, {}> {
    public static contextType = PlatformUserContext
    public context!: React.ContextType<typeof PlatformUserContext>

    public constructor(props: IProps) {
        super(props)
    }

    public render() {
        const { preAuth = false, ...props } = this.props
        const location = this.props.location!
        const currentRoute = location.pathname
        const queryString = location.search

        let redirectTo: string | null = null

        if (!this.context.authenticated) {
            if (!preAuth) {
                redirectTo = APP_BASE_ROUTE

                if (currentRoute !== APP_BASE_ROUTE) {
                    redirectTo += `?${AUTH_REDIRECT_PARAM}=${currentRoute}`
                }
            }
        } else {
            if (preAuth) {
                const redirectRequest = queryString.match(`${AUTH_REDIRECT_PARAM}=([^&]+)`)
                redirectTo = redirectRequest ? redirectRequest[1] : APP_BASE_ROUTE
            }
        }

        const path: string = ((props.path as any) || '').toString()
        return redirectTo !== null ? <Redirect from={path} exact={true} to={redirectTo} /> : <Route {...props} />
    }
}
